import { UserInfo } from '@cmp-src/components/UserInfo/UserInfo';
import { UserPropertyType } from '@gettactic/api';
import { useTeamAttendanceFilters } from 'v2/components/TeamSchedule/hooks/useTeamAttendanceFilters';

import { useAuthenticated } from '@gettactic/hooks';
import { SelectTeams } from 'v2/components/SelectTeams';
import { useEffect, useRef } from 'react';
import { InfiniteScroll } from '@gettactic/components/src/components/InfiniteScroll/InfiniteScroll';
import { MeetingUserGrid } from '@cmp-src/components/meeting/MeetingUserGrid/MeetingUserGrid';

const UsersSkeleton = ({ count = 1 }: { count?: number }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className='flex items-center rounded p-2'>
          <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
          <div className="ml-2 flex-1">
            <div className="h-3 bg-gray-200 rounded w-3/4 mb-2 animate-pulse" />
            <div className="h-2 bg-gray-200 rounded w-1/2 animate-pulse" />
          </div>
        </div>
      ))}
    </>
  );
};

export const UsersInOffice = ({ officeId }: { officeId: string }) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const {
    filters: dashboardFilters,
    isComponentLoading,
    totalUsers,
    tableOverviewData,
    setTeams,
    setOfficesId,
    handleSaveFilterData,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useTeamAttendanceFilters({
    authenticatedUser,
    currentOffice: { id: officeId }
  });

  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    handleSaveFilterData(
      UserPropertyType.LastOfficesFilter,
      officeId
    );
    setOfficesId(officeId);
  }, [officeId]);

  return (
    <div ref={scrollRef}>
      <div className="flex items-center justify-between">
        <div className="font-semibold text-sm">
          In the office ({totalUsers})
        </div>
        <SelectTeams
          includeFavs={true}
          teams={dashboardFilters.teams}
          applyOnClick={true}
          onChange={(teamIds: string[] | string) => {
            const teamIdsArray = Array.isArray(teamIds) ? teamIds : [teamIds];
            setTeams(teamIdsArray);
          }}
          className=""
          disabled={isComponentLoading}
          triggerClassName="mx-0 px-0"
        />
      </div>
      <MeetingUserGrid classNames="pt-6">
        {tableOverviewData.map((user) => (
          <UserInfo
            name={user.user.name}
            profile_photo_url={user.user?.profile_photo_url ?? ''}
            title={user.user.title}
            key={user.user.name}
          />
        ))}

        {/* Testing skeleton outside InfiniteScroll */}
        {/* <UsersSkeleton /> */}

        {hasNextPage && (
          <InfiniteScroll
            hasNextPage={!!hasNextPage}
            fetchNextPage={fetchNextPage || (() => {})}
            isFetchingNextPage={!!isFetchingNextPage}
            disabled={isComponentLoading || tableOverviewData.length === 0}
            offset={200}
            scrollRef={scrollRef}
            spinner={<UsersSkeleton />}
          />
        )}
      </MeetingUserGrid>
    </div>
  );
};
